<template>
  <div id="center">
    <div id="north">
      <header-info cur="2"></header-info>
    </div>
    <div class="content">
      <div class="course-info">
        <div class="course-center">
          <div class="course-news">
            <div class="course-title">{{lessonInfo?lessonInfo.title:'--'}}</div>
            <div class="course-semester">
              <span>学期：</span>
              <ul>
                <li>{{lessonInfo?formatTerm(lessonInfo.term):'--'}}</li>
              </ul>
            </div>
            <div class="course-attribute">
              <p>
                <span>学校：{{ lessonInfo.school ? lessonInfo.school.title : '' }}</span>
                <span>负责人：{{ lessonInfo.manager ? lessonInfo.manager.name : '--' }}</span>
              </p>
              <p>
                <span>所属专业类：{{lessonInfo.subject?lessonInfo.subject.subject_category.title:'--'}}</span>
                <span>对应专业：{{lessonInfo.subject?lessonInfo.subject.title:'--'}}</span>
              </p>
              <p>
                <span>课程学时：{{lessonInfo.allTime?lessonInfo.allTime:'--'}}学时</span>
                <span>授课语种：{{lessonInfo?$store.state.dict_basic_Lang[lessonInfo.lessonLang]:'--'}}</span>
              </p>
              <p>
                <span>课程对象：
                  <template v-if="lessonInfo.lessonObj">
                    <template v-if="lessonInfo.lessonObj.Obj1">本科生 </template>
                    <template v-if="lessonInfo.lessonObj.Obj2">专科生 </template>
                    <template v-if="lessonInfo.lessonObj.Obj3">社会学者</template>
                  </template>
                </span>
                <span>课程性质：
                  <template v-if="lessonInfo.lessonObj">
                    <template v-if="lessonInfo.lessonObj.Obj4">高校学分认定课 </template>
                    <template v-if="lessonInfo.lessonObj.Obj5">社会学习者课程</template>
                  </template>
                </span>
              </p>
              <p>课程时间： {{lessonInfo.startTime?formatDate(lessonInfo.startTime):'--'}} ~ {{lessonInfo.endTime?formatDate(lessonInfo.endTime):'--'}}</p>
            </div>
            <div class="progress-time hidebox">
              <div class="progress-bg">
                <div
                  class="skills progress"
                  :style="`width:${lessonInfo.progressWidth}%`"
                ></div>
              </div>
              <div>{{lessonInfo.currentWeek}}/{{lessonInfo.allTime?lessonInfo.allTime:'--'}}周</div>
            </div>
            <div class="course-brief">
              <span>简介：</span>
              <p
                class="course-brief-info"
                v-if="lessonInfo.recommend"
                v-html="lessonInfo.recommend"
              ></p>
              <p v-else>--</p>
            </div>
            <div
              class="course-btn hidebox"
              v-if="lessonInfo && formatTimeStatus(lessonInfo) == 2"
            >
              <button
                v-if="studentStatus==1"
                :class="studentStatus==1?'btn-color2':''"
                @click="toStudy"
              >去学习</button>
              <button
                v-else
                @click="addStudentInfo"
              >立即参与</button>
            </div>

          </div>
          <div class="course-bg">
            <img
              :src="lessonInfo.logoPath?lessonInfo.logoPath:'--'"
              width="500"
              height="335"
              :onerror="$store.state.defaultImg"
            >

          </div>
        </div>
      </div>
      <div
        class="course-btn mobile"
        v-if="lessonInfo && formatTimeStatus(lessonInfo) == 2"
      >
        <div
          class="btns-wrap"
          v-if="studentStatus==1"
        >
          <router-link
            :to="`/www/lesson/study?id=${this.lessonInfo.id}&studentId=${this.onlineStudent.id}`"
            class="btnOk btn-green"
          >进入课程</router-link>
          <a
            class="btnOk btn-yellow"
            href="javascript:;"
            @click="askDel()"
          >退出课程</a>
          <router-link
            class="btnOk btn-orange"
            :to="`/www/viewgrades?id=${this.onlineStudent.id}`"
          >查看成绩</router-link>
        </div>
        <button
          v-else
          class="join"
          @click="addStudentInfo"
        >立即参与</button>
      </div>
      <div class="course-main hidebox">
        <div class="course-left">
          <ul class="switch-tab">
            <li
              :class="isActive==1?'active':''"
              @click="isActive=1"
            >课程介绍</li>
          </ul>
          <div v-show="isActive==1">
            <div class="course-part">
              <div class="course-part-title">课程简介及课程特色</div>
              <div
                class="course-part-info"
                v-if="lessonInfo.brief"
                v-html="lessonInfo.brief"
              >
              </div>
              <div
                class="course-part-info"
                v-else
              >
                暂无内容
              </div>
            </div>
            <div class="course-part">
              <div class="course-part-title">参考资料</div>
              <div
                class="course-part-info"
                v-if="lessonInfo.references"
                v-html="lessonInfo.references"
              >
              </div>
              <div
                class="course-part-info"
                v-else
              >
                暂无内容
              </div>
            </div>
            <div class="course-part">
              <div class="course-part-title">常见问题</div>
              <div
                class="course-part-info"
                v-if="lessonInfo.questions"
                v-html="lessonInfo.questions"
              >
              </div>
              <div
                class="course-part-info"
                v-else
              >
                暂无内容
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="south"
      class="hidebox"
    >
      <footer-info></footer-info>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
export default {
  // 可用组件的哈希表
  components: { HeaderInfo, FooterInfo },

  data () {
    return {
      lessonInfo: {},
      queryInfo: {
        page: 1,
        size: 5,
        lessonOnline_id: this.$route.query.id
      },
      isActive: 1,
      studentStatus: 0,
      onlineStudent: null

    }
  },
  created() {
    this.getLessonInfo()
  },
  // 事件处理器
  methods: {

    // 格式化日期
    formatDate(value) {
      if (value.indexOf('.') < 0) {
        return value.replace('T', ' ')
      } else {
        return value.replace('T', ' ').substring(0, value.indexOf('.'))
      }
    },
    addZero(s) {
      return s < 10 ? ('0' + s) : s
    },
    getNowTime () {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      const second = date.getSeconds()
      const time = '' + year + '-' + this.addZero(month) + '-' + this.addZero(day) + ' ' + this.addZero(hour) + ':' + this.addZero(minute) + ':' + this.addZero(second)
      return time
    },
    formatTimeStatus (item) {
      if (!item.startTime || !item.endTime) {
        return 0
      }
      const curTime = this.getNowTime()
      if (item.startTime.replace('T', ' ') > curTime) {
        return 1
      }
      if (curTime >= item.startTime.replace('T', ' ') && item.endTime.replace('T', ' ') >= curTime) {
        return 2
      }
      if (curTime > item.endTime.replace('T', ' ')) {
        return 3
      }
      return 0
    },
    formatTerm(value) {
      var term = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      let text = ''
      if (value) {
        if (value.toString().length === 1) {
          text = term[value]
        } else if (value.toString().length === 2) {
          text = term[value.toString()[0]] + '十' + term[value.toString()[1]]
        } else if (value.toString().length === 3) {
          text = term[value.toString()[0]] + '百' + term[value.toString()[1]] + '十' + term[value.toString()[2]]
        } else if (value.toString().length === 4) {
          text = term[value.toString()[0]] + '千' + term[value.toString()[1]] + '百' + term[value.toString()[2]] + '十' + term[value.toString()[2]]
        }
        return '第' + text + '学期'
      } else {
        return '-'
      }
    },
    // 计算当前时间处于第几周
    getWeek (dt) {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      _this.gettime = yy + '-' + mm + '-' + dd
      const d1 = new Date(dt) // 开始时间
      const d2 = new Date(_this.gettime) // 当前时间日期
      const rq = d2 - d1
      const days = Math.ceil(rq / (24 * 60 * 60 * 1000))
      const num = Math.ceil(days / 7)
      return num
    },
    // 获取课程信息
    async getLessonInfo() {
      const url = '/allowany/lesson_online/' + this.$route.query.id + '/'
      await this.$http.get(url).then((data) => {
        if (data.id) {
          data.currentWeek = data.startTime ? this.getWeek(data.startTime) : '--'
          data.progressWidth = (data.currentWeek / data.allTime * 100).toFixed(2)
          data.lessonObj = JSON.parse(data.lessonObj)
          this.lessonInfo = data
          document.title = this.lessonInfo.title + ''
        }
      }).catch(() => {
        this.$layer.msg('获取课程信息失败！')
      })
    },
    async getStudentInfo() {
      const params = {
        page: 1,
        size: 10000,
        lessonOnline_id: this.$route.query.id,
        userProfile_id: this.$store.state.userInfo.profile_id
      }
      await this.$http.get('/allowany/online_student/', { params }).then((data) => {
        if (data.results.length) {
          this.studentStatus = 1
          this.onlineStudent = data.results[0]
        } else {
          this.studentStatus = 0
        }
      }).catch(() => {
        this.$layer.msg('获取选课学生信息失败！')
      })
    },
    toStudy () {
      this.$router.push('/my/lesson/detail?id=' + this.lessonInfo.id + '&studentId=' + this.onlineStudent.id)
      this.addLog()
    },
    async addStudentInfo() {
      if (!this.$store.state.userInfo.profile_id) {
        await this.$router.push('/login')
        return
      }
      await this.$http.post('/online_student_save/', {
        lessonOnline_id: this.$route.query.id,
        userProfile_id: this.$store.state.userInfo.profile_id
      }).then((data) => {
        if (data.code === '200') {
          this.$layer.msg('操作成功')
        } else {
          this.$layer.msg(data.msg)
        }
        this.getStudentInfo()
      }).catch(() => {
        this.$layer.msg('操作失败！')
      })
    },
    async viewCount() {
      await this.$http.post('/lesson_view_count/', {
        id: this.$route.query.id
      }).then((data) => {

      }).catch((error) => {
        console.log(error)
      })
    },
    async addLog() {
      await this.$http.post('/user_log/', {
        userprofile_id: this.$store.state.userInfo.profile_id,
        category: 3,
        content: `课程名称：${this.lessonInfo ? this.lessonInfo.title : '--'}`
      }).then(async (data) => {

      }).catch(() => {
        this.$layer.msg('添加日志失败！')
      })
    },
    async askDel() {
      const url = '/online_student/' + this.onlineStudent.id + '/'
      await this.$http.put(url, {
        isdel: 1
      }).then((data) => {
        this.getStudentInfo()
        this.$layer.msg('退出成功!')
      }).catch((error) => {
        console.log(error)
      })
    }

  },
  // 生命周期-实例挂载后调用
  async mounted () {
    await this.getStudentInfo()
    await this.viewCount()
  }
}
</script>

<style lang="less" scoped>
body {
  background: #f4f4f4;
}
.content {
  padding-bottom: 20px;
}
.course-info {
  background: #2f3a59;
  position: relative;
  overflow: hidden;
  &::after {
    content: "";
    display: block;
    position: absolute;
    width: 960px;
    height: 580px;
    top: 50%;
    left: -200px;
    transform: translateY(-70%);
    z-index: 1;
    background: rgba(116, 69, 103, 1);
    background: -moz-radial-gradient(
      center,
      ellipse cover,
      rgba(116, 69, 103, 1) 0%,
      rgba(116, 69, 103, 1) 22%,
      rgba(106, 65, 102, 1) 35%,
      rgba(86, 60, 93, 1) 46%,
      rgba(47, 58, 89, 1) 66%,
      rgba(47, 58, 89, 1) 100%
    );
    background: -webkit-gradient(
      radial,
      center center,
      0px,
      center center,
      100%,
      color-stop(0%, rgba(116, 69, 103, 1)),
      color-stop(22%, rgba(116, 69, 103, 1)),
      color-stop(35%, rgba(106, 65, 102, 1)),
      color-stop(46%, rgba(86, 60, 93, 1)),
      color-stop(66%, rgba(47, 58, 89, 1)),
      color-stop(100%, rgba(47, 58, 89, 1))
    );
    background: -webkit-radial-gradient(
      center,
      ellipse cover,
      rgba(116, 69, 103, 1) 0%,
      rgba(116, 69, 103, 1) 22%,
      rgba(106, 65, 102, 1) 35%,
      rgba(86, 60, 93, 1) 46%,
      rgba(47, 58, 89, 1) 66%,
      rgba(47, 58, 89, 1) 100%
    );
    background: -o-radial-gradient(
      center,
      ellipse cover,
      rgba(116, 69, 103, 1) 0%,
      rgba(116, 69, 103, 1) 22%,
      rgba(106, 65, 102, 1) 35%,
      rgba(86, 60, 93, 1) 46%,
      rgba(47, 58, 89, 1) 66%,
      rgba(47, 58, 89, 1) 100%
    );
    background: -ms-radial-gradient(
      center,
      ellipse cover,
      rgba(116, 69, 103, 1) 0%,
      rgba(116, 69, 103, 1) 22%,
      rgba(106, 65, 102, 1) 35%,
      rgba(86, 60, 93, 1) 46%,
      rgba(47, 58, 89, 1) 66%,
      rgba(47, 58, 89, 1) 100%
    );
    background: radial-gradient(
      ellipse at center,
      rgba(116, 69, 103, 1) 0%,
      rgba(116, 69, 103, 1) 22%,
      rgba(106, 65, 102, 1) 35%,
      rgba(86, 60, 93, 1) 46%,
      rgba(47, 58, 89, 1) 66%,
      rgba(47, 58, 89, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#744567', endColorstr='#2f3a59', GradientType=1);
  }
  .course-center {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .course-news {
      color: #fff;
      line-height: 30px;
      .course-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .course-semester {
        font-size: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        span {
          font-weight: bold;
        }
        ul {
          border: 1px solid #eee;
          padding: 2px 10px;
        }
      }
      .course-attribute {
        p {
          font-size: 14px;
          span {
            display: inline-block;
            min-width: 230px;
          }
        }
      }
      .course-brief {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 10px;
        .course-brief-info {
          width: 600px;
          height: 60px;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 2;
          // -webkit-box-orient: vertical;
          overflow-y: auto;
        }
      }
      .course-btn {
        button {
          font-size: 16px;
          background: #4977e9;
          color: #fff;
          border: none;
          padding: 10px 20px;
          border-radius: 5px;
          cursor: pointer;
        }
        .btn-color1 {
          background: #e73232;
        }
        .btn-color2 {
          background: #e79332;
        }
      }
    }
    .course-bg {
      img {
        width: 500px;
        height: 335px;
      }
    }
  }
}

.progress-time {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;
}
.progress-bg {
  width: 300px;
  background-color: #ddd;
  border-radius: 5px;
  margin-right: 20px;
  overflow: hidden;
}
.skills {
  text-align: right;
  padding-right: 20px;
  line-height: 20px;
  color: white;
}
.progress {
  width: 10%;
  height: 20px;
  background-color: #4caf50;
}
.course-main {
  width: 1200px;
  margin: 20px auto 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .course-left {
    width: 1200px;
    background: #fff;
    .switch-tab {
      margin-top: 20px;
      border-bottom: 1px solid #eee;
      li {
        cursor: pointer;
        height: 42px;
        line-height: 42px;
        color: #4c4c4c;
        font-size: 16px;
        margin-right: 10px;
        margin-left: 20px;
        padding: 0 10px;
        display: inline-block;
      }
      li.active {
        color: #fff;
        background: #4977e9;
      }
    }
    .course-part {
      padding: 20px 30px;
      .course-part-title {
        padding: 20px 0;
        color: #1a61ac;
        font-size: 16px;
      }
      .course-part-info {
        color: #999;
        line-height: 25px;
      }
    }
    .experiment-list {
      ul {
        li {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
        }
      }
      .course-experiment-img {
        width: 220px;
        height: 150px;
        position: relative;
        overflow: hidden;
        img {
          max-width: 100%;
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }
      }
      .course-experiment-info {
        margin-top: 20px;
        margin-left: 20px;
        .experiment-title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .experiment-manage {
          font-size: 16px;
          color: #555;
          span {
            margin-right: 30px;
          }
        }
        .experiment-chapter {
          font-size: 16px;
          color: #555;
          margin-bottom: 20px;
          span {
            margin-left: 20px;
          }
        }
      }
    }
  }
  .course-right {
    width: 270px;
    background: #fff;
    .course-right-title {
      color: #4d4d4d;
      font-weight: bold;
      font-size: 16px;
      padding: 20px;
      border-bottom: 1px solid #eee;
      position: relative;
      margin-bottom: 20px;
    }
    ul {
      li {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;
        .head-pic {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          overflow: hidden;
          position: relative;
          margin: 0 20px;
          border: 1px solid #eee;
          img {
            // max-width: 100%;
            // position: absolute;
            // left: 0;
            // top: 0;
            // right: 0;
            // bottom: 0;
            // margin: auto;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .teacher-info {
          color: #555;
          font-size: 15px;
          line-height: 25px;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .course-info .course-center .course-news .course-brief .course-brief-info {
    width: auto !important;
    flex: 1;
    height: auto;
    text-overflow: unset;
    display: block;
  }
  .btns-wrap {
    margin: 10px 0;
    overflow: hidden;
    text-align: center;
    .btnOk {
      display: inline-block;
      padding: 0 10px;
      height: 36px;
      line-height: 36px;
      border-radius: 5px;
      color: #fff;
      margin-right: 10px;
    }
    .btn-green {
      background: #25c7a8;
    }
    .btn-yellow {
      background: #f7b500;
    }
    .btn-orange {
      background: #fa6400;
    }
  }
}
</style>
